export const iconFontAwesomeMapsGraduationCap = (
	<i className="fa-solid fa-graduation-cap"></i>
);
